import type { ReactNode } from "react";

/**
 * Outer chrome shared by every route. Just paints the canvas color so the
 * page (Login or Dashboard) can own its own layout without competing with
 * any global aurora / floating chrome.
 */
export function AppShell({ children }: { children: ReactNode }) {
  return <div className="min-h-dvh bg-[var(--color-bg)]">{children}</div>;
}
